import { render, staticRenderFns } from "./UserSettingsAccount.vue?vue&type=template&id=9b350c46&scoped=true&"
import script from "./UserSettingsAccount.vue?vue&type=script&lang=js&"
export * from "./UserSettingsAccount.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingsAccount.vue?vue&type=style&index=0&id=9b350c46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b350c46",
  null
  
)

export default component.exports